import React from 'react';
import { Container, Heading } from '@chakra-ui/react';

const Layout: React.FC = () => {
  return (
    <Container>
      <Heading>문장 배열하기</Heading>
    </Container>
  );
};

export default Layout;
